import { Link } from 'react-router-dom';

/**
 * Route fallback page.
 */
export function NotFoundPage() {
  return (
    <section className="page">
      <div className="card">
        <h1 className="section-heading">Page Not Found</h1>
        <p>The route you requested does not exist.</p>
        <Link className="btn btn-primary" to="/">
          Go Home
        </Link>
      </div>
    </section>
  );
}
